var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2177 2.77406C9.69359 3.50085 8.85504 4.07409 8.01649 3.9922C7.91167 3.0095 8.32221 1.96539 8.80263 1.3205C9.32672 0.573238 10.2439 0.0409456 10.9863 0C11.0737 1.02364 10.733 2.02681 10.2177 2.77406V2.77406Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1502 5.00567C9.63434 4.91835 8.33655 5.86797 7.61677 5.86797C6.88608 5.86797 5.78459 5.04933 4.58495 5.07116C3.02542 5.09299 1.57495 5.97712 0.778822 7.38517C-0.85705 10.2013 0.353495 14.3709 1.93484 16.663C2.70915 17.7982 3.63614 19.0425 4.8576 18.9989C6.01361 18.9552 6.47166 18.2457 7.8676 18.2457C9.27445 18.2457 9.67796 18.9989 10.8994 18.9771C12.1645 18.9552 12.9606 17.8419 13.7349 16.7067C14.6183 15.4187 14.9782 14.1635 15 14.098C14.9782 14.0762 12.5571 13.1484 12.5353 10.3541C12.5135 8.01825 14.4438 6.90491 14.5311 6.83942C13.4405 5.22398 11.7392 5.04933 11.1502 5.00567V5.00567Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplepay);
export default __webpack_public_path__ + "static/media/applepay.ddeb97a464d6e4b24add9a43a8c9c3a9.svg";
export { ForwardRef as ReactComponent };